import React from 'react';
import PropTypes from 'prop-types';
//  components
import {Button, PrimaryButton} from 'components/lib/buttons/Button';
import ControlledSelect from 'components/lib/formElements/ControlledSelect';
// material ui
import Dialog from 'material-ui/Dialog';
import Menu from 'material-ui/Menu';
import TextField from 'material-ui/TextField';
//utils
import { getProductionMenuItems } from 'utils/utils';
import styles from 'styles/components/series/modals/seriesModal.css';

export default class SeriesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      error: null,
      showMenu: false
    }
    this.handleEnter = this.handleEnter.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleChangeMenu = this.handleChangeMenu.bind(this);
  }
  getProductionId = (request) => {
    let { productions } = this.props;
    let filteredProductions = productions.filter( production  => {
      return production.productionName.toLowerCase() === request;
    });

    return filteredProductions[0];
  }
  handleEnter(e, newValue ){
    if (e.key === "Enter") {
      let production = this.getProductionId(e.target.value.toLowerCase());
      if (production) this.props.onChange(production.productionId);
      else this.setError();
    }
  }
  toggleMenu(e) {
    e.preventDefault();
    this.setState({ showMenu: !this.state.showMenu});
  }
  handleChangeMenu(e, id) {
    this.props.onChange(id);
  }
  setError() {
    console.log('WRONG');
    this.setState({ error: this.props.labels.error }, () => {
      setTimeout(() => { this.setState({error: null}); }, 1800);
    })
  }
  renderWelcomeDialog = () => {
    return (
      <div>
        <TextField
          className={styles.inputSeries}
          errorText={this.state.error}
          floatingLabelText={this.props.labels.placeholder}
          floatingLabelStyle={{width: '100%', textAlign: 'center', color: '#666666', fontSize: '20px'}}
          floatingLabelFocusStyle={{color: '#888'}}
          floatingLabelShrinkStyle={{textAlign: 'left', color: '#888'}}
          id="seriesNameInput"
          name="seriesNameInput"
          onKeyDown={this.handleEnter} />
        <p style={{margin: '20px'}}>Or</p>
        <PrimaryButton label="Choose a Series" onClick={this.toggleMenu}/>
      </div>
    );
  }
  renderMenu = () => {
    let items = getProductionMenuItems(this.props.productions).map(prod => prod.value);
    console.log(items);
    return(
      <div style={{height: '250px'}}>
      <Button className={styles.backBtn} label="Back" onClick={this.toggleMenu}/>
      <Menu onChange={this.handleChangeMenu} onEscKeyDown={this.toggleMenu} >
        {items}
      </Menu>
      </div>
    );
  }
  render() {
    let { showMenu } = this.state;
    let { productions, clientId, open } = this.props;
    let { error, label } = this.props.labels;
    let { isTouchDevice } = this.context.media;
    let welcomeStyle={padding: '50px', textAlign: 'center'};
    let menuStyle={paddingLeft: '0px', paddingRight: '0px'};
    return (
      <Dialog
        autoScrollBodyContent={true}
        bodyStyle={isTouchDevice && (showMenu ? menuStyle : welcomeStyle)}
        className={!isTouchDevice ? styles.seriesModal
          : (showMenu ? styles.seriesModalMenu : styles.seriesModalWelcome ) }
        contentStyle={{ width: '500px', overflowX: 'hidden'}}
        id="seriesModal"
        modal={true}
        open={open}
        title={!isTouchDevice || showMenu  ? "Choose a series" : ""   } >
        { isTouchDevice ?
          (!showMenu ? this.renderWelcomeDialog() : this.renderMenu())
          : <ControlledSelect
              ref="controlledSelect"
              clientId={clientId}
              error={error}
              items={productions}
              isDialog={true}
              label={label}
              onChange={this.props.onChange} />
        }
      </Dialog>
    );
  }
}
SeriesModal.contextTypes = {
  media: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/scripts/components/series/modals/SeriesModal.js